<script>
  import AdminNav from '@/components/admin/AdminNav.svelte';
  import { router } from '@inertiajs/svelte'

  let { categories = [], pagination = {}, stats = {}, flash = {} } = $props()

  function goToPage(page) {
    router.get('/admin/categories', { page }, { preserveState: true })
  }

  function toggleVisibility(categoryId) {
    router.post(`/admin/categories/${categoryId}/toggle_visibility`, {}, { preserveState: false })
  }
</script>

<AdminNav activeTab="categories" />

  <main>
    {#if flash.notice}
      <div class="mb-6 p-4 bg-success-light dark:bg-success/20 border border-success/30 rounded-xl text-success-dark dark:text-success text-body2">
        {flash.notice}
      </div>
    {/if}
    {#if flash.alert}
      <div class="mb-6 p-4 bg-error-light dark:bg-error/20 border border-error/30 rounded-xl text-error-dark dark:text-error text-body2">
        {flash.alert}
      </div>
    {/if}

    <div class="flex items-center justify-between mb-6">
      <div class="flex items-center gap-4">
        <h2 class="text-h1 text-content">카테고리 관리</h2>
        <div class="flex items-center gap-2 text-body2">
          <span class="px-3 py-1 bg-surface-tertiary text-content-secondary rounded-lg">전체 {stats.total || 0}</span>
          <span class="px-3 py-1 bg-primary-50 dark:bg-primary/20 text-primary rounded-lg">루트 {stats.root || 0}</span>
        </div>
      </div>
      <a href="/admin/categories/new" class="btn btn-primary btn-md">+ 카테고리 추가</a>
    </div>

    <!-- Categories Tree -->
    <div class="space-y-3">
      {#each categories as category}
        <div class="card card-bordered shadow-md overflow-hidden">
          <!-- Parent Category -->
          <div class="px-6 py-4 flex items-center justify-between hover:bg-gray-50 dark:hover:bg-dark-tertiary transition-colors {category.is_visible ? '' : 'opacity-50'}">
            <div class="flex items-center gap-3">
              {#if category.color}
                <span class="w-4 h-4 rounded-full shrink-0" style="background-color: {category.color}"></span>
              {:else}
                <span class="w-4 h-4 rounded-full shrink-0 bg-gray-300 dark:bg-dark-border"></span>
              {/if}
              <div>
                <div class="text-body1 font-medium text-content">{category.name}</div>
                <div class="text-caption text-content-tertiary">
                  /{category.slug} · 게시글 {category.posts_count}개
                  {#if category.boards.length > 0}
                    · 게시판: {category.boards.map(b => b.name).join(', ')}
                  {/if}
                </div>
              </div>
            </div>
            <div class="flex items-center gap-3">
              <button
                onclick={() => toggleVisibility(category.id)}
                class="relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/30 {category.is_visible ? 'bg-primary' : 'bg-gray-300 dark:bg-dark-border'}"
                role="switch"
                aria-checked={category.is_visible}
                title={category.is_visible ? '표시 중 (클릭하여 숨기기)' : '숨김 (클릭하여 표시)'}
              >
                <span
                  class="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out {category.is_visible ? 'translate-x-5' : 'translate-x-0'}"
                ></span>
              </button>
              <a href={`/admin/categories/${category.id}`} class="text-primary hover:text-primary-dark text-body2 font-medium">상세</a>
              <a href={`/admin/categories/${category.id}/edit`} class="text-gray-500 hover:text-gray-700 dark:text-dark-text-low dark:hover:text-dark-text-high text-body2">수정</a>
            </div>
          </div>

          <!-- Children Categories -->
          {#if category.children && category.children.length > 0}
            <div class="border-t border-gray-100 dark:border-dark-border">
              {#each category.children as child}
                <div class="px-6 py-3 pl-14 flex items-center justify-between hover:bg-gray-50 dark:hover:bg-dark-tertiary transition-colors border-t border-gray-50 dark:border-dark-border/50 {child.is_visible ? '' : 'opacity-50'}">
                  <div class="flex items-center gap-3">
                    <span class="text-gray-400 dark:text-dark-text-disabled">└</span>
                    {#if child.color}
                      <span class="w-3 h-3 rounded-full shrink-0" style="background-color: {child.color}"></span>
                    {/if}
                    <div>
                      <span class="text-body2 text-gray-700 dark:text-dark-text-medium">{child.name}</span>
                      <span class="text-caption text-content-tertiary ml-2">게시글 {child.posts_count}개</span>
                    </div>
                  </div>
                  <div class="flex items-center gap-3">
                    <button
                      onclick={() => toggleVisibility(child.id)}
                      class="relative inline-flex h-5 w-9 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/30 {child.is_visible ? 'bg-primary' : 'bg-gray-300 dark:bg-dark-border'}"
                      role="switch"
                      aria-checked={child.is_visible}
                      title={child.is_visible ? '표시 중' : '숨김'}
                    >
                      <span
                        class="pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out {child.is_visible ? 'translate-x-4' : 'translate-x-0'}"
                      ></span>
                    </button>
                    <a href={`/admin/categories/${child.id}`} class="text-primary hover:text-primary-dark text-caption">상세</a>
                    <a href={`/admin/categories/${child.id}/edit`} class="text-gray-500 hover:text-gray-700 dark:text-dark-text-low text-caption">수정</a>
                  </div>
                </div>
              {/each}
            </div>
          {/if}
        </div>
      {/each}
    </div>

    {#if categories.length === 0}
      <div class="card card-bordered p-12 text-center text-content-tertiary shadow-md">
        카테고리가 없습니다
      </div>
    {/if}

    <!-- Pagination -->
    {#if pagination.total_pages > 1}
      <div class="flex items-center justify-center gap-2 mt-6">
        <button onclick={() => goToPage(pagination.current_page - 1)} disabled={pagination.current_page === 1} class="btn btn-secondary btn-sm disabled:opacity-50 disabled:cursor-not-allowed">이전</button>
        <span class="px-4 py-2 text-body2 text-content-tertiary">{pagination.current_page} / {pagination.total_pages}</span>
        <button onclick={() => goToPage(pagination.current_page + 1)} disabled={pagination.current_page === pagination.total_pages} class="btn btn-secondary btn-sm disabled:opacity-50 disabled:cursor-not-allowed">다음</button>
      </div>
    {/if}
  </main>
